// WhatsAppChatbotButton.js
import React from 'react';

const WhatsAppChatbotButton = () => {
  const phoneNumber = '919975267711'; // your testing number with country code
  const message = 'Hi, I want to know more about your services.'; // initial message

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div style={{ position: 'fixed', bottom: 20, right: 20, zIndex: 1000 }}>
      <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
        <img
          src="https://img.icons8.com/color/48/000000/whatsapp.png"
          alt="Chat on WhatsApp"
          style={{ width: 60, height: 60 }}
        />
      </a>
    </div>
  );
};

export default WhatsAppChatbotButton;
